<ng-container *ngIf="form">
    <form [formGroup]="form">
        <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Name</mat-label>
            <input matInput placeholder="" [formControlName]="'name'" />
        </mat-form-field>
        <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Description</mat-label>
            <input matInput placeholder="" [formControlName]="'description'" />
        </mat-form-field>
        <div formGroupName="data" class="data">
            <mat-form-field appearance="fill" floatLabel="always">
                <mat-label>Title</mat-label>
                <input matInput placeholder="" [formControlName]="'title'" />
            </mat-form-field>
            <mat-form-field appearance="fill" floatLabel="always">
                <mat-label>Subject</mat-label>
                <input matInput placeholder="" [formControlName]="'subject'" />
            </mat-form-field>
            <mat-form-field appearance="fill" floatLabel="always">
                <mat-label>Header</mat-label>
                <input matInput placeholder="" [formControlName]="'header'" />
            </mat-form-field>
            <mat-form-field appearance="fill" floatLabel="always">
                <mat-label>Body</mat-label>
                <textarea matInput placeholder="" [formControlName]="'body'"></textarea>
            </mat-form-field>
            <mat-form-field appearance="fill" floatLabel="always">
                <mat-label>Footer</mat-label>
                <input matInput placeholder="" [formControlName]="'footer'" />
            </mat-form-field>
        </div>
        <div class="groups">
            <h3>Target Groups {{ countSelectedGroups() }}</h3>
            <div class="groups-container">
                <ng-container formArrayName="groups">
                    <mat-checkbox *ngFor="let group of groups; let i = index" [formControlName]="i">
                        {{ group.name }}
                    </mat-checkbox>
                </ng-container>
            </div>
        </div>
    </form>
</ng-container>
<app-inlinemessage *ngIf="errorMessage" level="error" [message]="errorMessage"></app-inlinemessage>
<span class="required">* Required Field</span>
